<template>
  <dialog-view :open="open" title="О чате" @cancel="close()" contentFullSize>
    <template v-slot:content>
      <v-text-field
          :disabled="chat.cat!=='internal' || chat.dialogUsers.length===2"
          class="ma-3"
          v-model="chatName"
          label="Название"
          outlined dense hide-details
      />
      <v-divider/>
      <toolbar-view title="Участники">
        <template v-slot:barActions>
          <v-btn
              v-if="!isMember"
              :loading="joinChatState.loading"
              class="mr-2"
              depressed small
              @click="joinChat"
          >
            <v-icon class="mr-2" small>mdi-account-arrow-right</v-icon>
            Присоединиться
          </v-btn>
          <v-btn depressed small @click="inviteChatOpen=true">
            <v-icon class="mr-2" small>mdi-account-plus</v-icon>
            Добавить
          </v-btn>
        </template>
      </toolbar-view>
      <dialog-page-invite-chat
          :key="chat?.id"
          :chat-id="chat?.id"
          :open="inviteChatOpen"
          @cancel="inviteChatOpen=false"
          @invited="inviteChatOpen=false"
      />
      <v-sheet outlined rounded class="mx-3 mb-3">
        <v-list class="pa-0" dense color="transparent">
          <template v-for="(dialogUser, i) in localDialogUsers">
            <v-list-item :key="chat.id + '-' + dialogUser.id" class="py-0 px-2">
              <v-row no-gutters class="full-width py-2 px-1">
                <v-col cols="auto" class="mr-2 mt-1">
                  <v-avatar size="30" color="white">
                    <img v-if="dialogUser.user && dialogUser.user.imageUrl" :src="dialogUser.user.imageUrl">
                    <v-icon v-else large>mdi-account-circle</v-icon>
                  </v-avatar>
                </v-col>
                <v-col>
                  <v-row align="center" no-gutters>
                    <v-col cols="12">
                      <div class="body-2">
                        <span>{{ dialogUser.user === null ? 'Аноним' : $tools.userFullName(dialogUser.user) }}</span>
                        <span
                            v-if="(dialogUser.user===null ? 'Аноним' : $tools.userFullName(dialogUser.user))!==dialogUser.name">
                      - {{ dialogUser.name }}
                    </span>
                      </div>
                      <div class="body-2 caption">
                        <span>{{ $tools.userGender(dialogUser.user) }}</span>
                        <dot/>
                        <span>{{ $tools.userYears(dialogUser.user) }}</span>
                        <dot/>
                        <span>{{ $tools.userTypeName(dialogUser.user?.type) }}</span>
                        <dot/>
                        <span>{{ $tools.dialogProviderName(dialogUser.provider) }}</span>
                      </div>
                    </v-col>
                    <v-col class="pt-1" cols="12">
                      <v-btn
                          :disabled="dialogUser.user===null"
                          class="mr-2"
                          depressed small
                          @click="$tools.openUrl('/panel/user/'+dialogUser.user?.type+'/'+dialogUser.user?.id+'/', true)"
                      >
                        Профиль
                        <v-icon class="ml-2" dense small>mdi-open-in-new</v-icon>
                      </v-btn>

                      <btn-small-accept
                          :loading="excludeUserId===dialogUser.user?.id && excludeUserState.loading"
                          :name="canExclude(dialogUser) ? 'Исключить' : 'Покинуть'"
                          icon="mdi-account-box-minus-outline"
                          text="Исключить пользователя из чата?"
                          @accept="excludeUser(dialogUser)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-list-item>
            <v-divider v-if="i<localDialogUsers.length-1" :key="'d'+chat.id+'-'+dialogUser.id"/>
          </template>
        </v-list>
      </v-sheet>
    </template>
    <template v-slot:actions>
      <v-btn v-if="chat.dialogUsers.length>2" :loading="saveChatState.loading" color="primary" text @click="saveChat()">
        Сохранить
      </v-btn>
    </template>
  </dialog-view>
</template>

<script>
import DialogView from "@/components/DialogView.vue";
import Dot from "@/componentsV2/base/Dot.vue";
import BtnSmallAccept from "@/componentsV2/base/BtnSmallAccept.vue";
import axios from "axios";
import Stater from "../../../../plugins/stater";
import DialogPageInviteChat from "./DialogPageInviteChat.vue";
import ToolbarView from "../../../../components/ToolbarView.vue";

export default {
  components: {ToolbarView, DialogPageInviteChat, DialogView, Dot, BtnSmallAccept},
  props: ['open', 'chat'],
  data: () => ({
    chatName: null,
    localDialogUsers: [],
    saveChatState: new Stater(),
    excludeUserState: new Stater(),
    excludeUserId: null,
    inviteChatOpen:false,
    joinChatState: new Stater(),
  }),
  computed: {
    isMember() {
      const userId = this.$store.state.user?.id;
      return (this.chat?.dialogUsers || []).some(
          v => v.user?.id === userId && v.provider === 'internal'
      );
    },
  },
  watch: {
    open(v) {
      if (v) this.reset();
    },
    'chat.dialogUsers': {
      handler() {
        if (this.open)
          this.syncDialogUsers();
      },
      deep: true,
    },
    'chat.id'() {
      this.inviteChatOpen = false;
      if (this.open) this.reset();
    },
  },
  methods: {
    syncDialogUsers() {
      this.localDialogUsers = [...(this.chat?.dialogUsers || [])];
    },
    reset() {
      this.syncDialogUsers();
      this.chatName = this.chat?.name ?? null;
      this.saveChatState.stateInit();
      this.excludeUserState.stateInit();
      this.excludeUserId = null;
      this.joinChatState.stateInit();
    },
    close() {
      this.reset();
      this.$emit('cancel');
    },
    canExclude(dialogUser) {
      return dialogUser.user?.id !== this.$store.state.user?.id || dialogUser.provider !== 'internal';
    },
    saveChat() {
      if (this.chat === null)
        return;

      this.saveChatState.stateLoading();
      axios.put('/napi/dialog/chat/' + this.chat.id + '/', {
        name: this.chatName,
      })
          .then(r => {
            this.saveChatState.stateSuccess();
            this.$emit('saved', r.data);
            this.close();
          })
          .catch(e => {
            this.saveChatState.stateError(e.response?.data?.message);
          });
    },
    joinChat() {
      if (this.chat === null)
        return;
      this.joinChatState.stateLoading();
      axios.post('/napi/dialog/chat/' + this.chat.id + '/join/', {
        onlyMeAsInternal: true,
      }).then(() => {
        this.joinChatState.stateSuccess();
      }).catch(() => {
        this.joinChatState.stateError();
      });
    },
    excludeUser(dialogUser) {
      if (this.chat === null || dialogUser.user === null)
        return;

      this.excludeUserId = dialogUser.user.id;
      this.excludeUserState.stateLoading();
      axios.post('/napi/dialog/chat/' + this.chat.id + '/leave/', {
        dialogUserId: dialogUser.id,
      })
          .then(() => {
            this.localDialogUsers = this.localDialogUsers.filter(v => v.id !== dialogUser.id);
            this.excludeUserState.stateSuccess();
            this.excludeUserId = null;
            this.$emit('excluded');
          })
          .catch(e => {
            this.excludeUserState.stateError(e.response?.data?.message);
            this.excludeUserId = null;
          });
    },
  },
}
</script>
